// TeamMember.jsx
import React from 'react';
import Lottie from 'lottie-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import Fan from '../Animation/fan.json';
import { FaArrowLeft, FaArrowRight} from 'react-icons/fa';

const teamData = [
    {
      name: 'Kathryn Murphy',
      role: 'Managing Partner',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_5.jpg&w=640&q=75',
    },
    {
      name: 'Marvin McKinney',
      role: 'President Of Sales',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_6.jpg&w=640&q=75',
    },
    {
      name: 'Darlene Robertson',
      role: 'Project Manager',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_7.jpg&w=640&q=75',
    },
    {
      name: 'Cameron William',
      role: 'Managing Partner',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_8.jpg&w=640&q=75',
    },
    {
      name: 'Marvin McKinney',
      role: 'President Of Sales',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_6.jpg&w=640&q=75',
    },
    {
      name: 'Darlene Robertson',
      role: 'Project Manager',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_7.jpg&w=640&q=75',
    },
    {
      name: 'Cameron William',
      role: 'Managing Partner',
      image: 'https://arkdin-nextjs.vercel.app/_next/image?url=%2Fassets%2Fimg%2Fteam_member_8.jpg&w=640&q=75',
    },
  ];

const TeamMember = () => {
  return (
    <div className="px-6 md:px-20 py-10 relative">
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <Lottie className="w-6" animationData={Fan} />
        <h1 className="sm:text-2xl text-xl text-orange-500 font-bold">OUR TEAM MEMBERS</h1>
      </div>
      <p className="sm:text-3xl text-2xl font-bold mb-10">Our Professional Expert Team</p>

      {/* Slider */}
      <div className="relative">
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: '.nextBtn',
            prevEl: '.prevBtn',
          }}
          spaceBetween={30}
          slidesPerView={4}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {teamData.map((member, index) => (
            <SwiperSlide key={index} className='p-4'>
              <div className="bg-white group  rounded-lg shadow-lg  mx-auto relative ">
                {/* Image */}
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-top"
                />

                {/* Triangle cut-out */}
                {/* <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-0 h-0 
                  border-l-[15px] border-l-transparent
                  border-b-[15px] border-b-orange-500
                  border-r-[15px] border-r-transparent">
                </div> */}

<div className='absolute z-10 -left-5 bottom-[71px] h-16 rotate-180 '>
                 <div className=' w-5  h-full group-hover:bg-orange-600 bg-orange-50 -skew-y-[20deg] absolute top-10'></div>
                 <div className=' w-5 h-full group-hover:bg-orange-600 bg-orange-50 skew-y-[20deg] '></div>
                 </div>

                {/* Orange social bar */}
                {/* <div className="relative group-hover:bg-orange-600 bg-orange-50 py-8 mt-5  "> */}
                  {/* Icons */}
                
                  {/* <div className="flex justify-center gap-4 ">
                    <FaLinkedinIn className="text-orange-500 text-lg bg-white hover:bg-[#010f34] w-6 h-6 p-[2px] duration-200" />
                    <FaVimeoV className="text-orange-500 text-lg bg-white hover:bg-[#010f34] w-6 h-6 p-[2px] duration-200" />
                    <FaTwitter className="text-orange-500 text-lg bg-white hover:bg-[#010f34] w-6 h-6 p-[2px] duration-200" />
                    <FaFacebookF className="text-orange-500 text-lg bg-white hover:bg-[#010f34] w-6 h-6 p-[2px] duration-200" />
                  </div> */}
                {/* </div> */}

                {/* Name & Role */}
                {/* <div className="text-center px-4 py-4">
                  <h2 className="text-lg font-bold text-gray-800">{member.name}</h2>
                  <p className="text-sm text-gray-500">{member.role}</p>
                </div> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Arrows */}
        <div className="absolute -top-10 sm:-top-16 right-0 flex gap-3">
          <button className="prevBtn bg-orange-500 hover:bg-[#010f34] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl transition">
            <FaArrowLeft className='w-4' />
          </button>
          <button className="nextBtn bg-orange-500 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl hover:bg-[#010f34] transition">
            <FaArrowRight className='w-4' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;